require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-hazeldellribboncutting.json") })
        }
      }, "path---articles-hazeldellribboncutting");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-hazeldellribboncutting!./.cache/json/articles-hazeldellribboncutting.json
// module id = 1697
// module chunks = 231608221292675